import regsStatsReducer, {
  APPLY,
  REORDER_COLUMNS,
  SET_FILTERS,
} from './regsStatsReducer';

export default function trackerTemporaryStateReducer(state, action) {
  switch (action.type) {
    case APPLY: {
      const actionBeforeApply = action.payload;
      let newState = state.temporary ? state.temporary : state;

      newState = actionBeforeApply
        ? regsStatsReducer(newState, actionBeforeApply)
        : newState;

      newState = regsStatsReducer(state, {
        type: APPLY,
        payload: newState,
      });

      return {
        ...newState,
        ready: true,
        temporary: null,
      };
    }

    case REORDER_COLUMNS:
    case SET_FILTERS: {
      const temporaryState = ensureTemporaryState(state);
      return {
        ...state,
        temporary: regsStatsReducer(temporaryState, action),
      };
    }

    default:
      return regsStatsReducer(
        {
          ...state,
          ...(state.temporary
            ? {
                temporary: regsStatsReducer(state.temporary, action),
              }
            : null),
        },
        action
      );
  }
}

export function ensureTemporaryState({ temporary, ...state }) {
  return temporary ? temporary : state;
}
